<template>
  <div class="container">
    <div class="col-md-8 col-sm-10 mx-auto">
      <div class="btn-toolbar">
        <router-link to="/bulkimport">
          <button type="button" class="btn btn-secondary">Bulk Key Import</button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'admin',
  props: ['user'],
  data() {
    return {}
  },
  mounted() {
    if (!this.userIsInGroup('admins')) {
      this.$router.push('/')
    }
  },
  methods: {
    userIsInGroup(group) {
      // The token payload holds an array of groups the user is in and indexOf will return the
      // index of the group name if it is found but -1 if it is not
      try {
        return this.user.signInUserSession.accessToken.payload['cognito:groups'].indexOf(group) > -1
      } catch {
        // User wasn't logged in so token didn't exist
        return false
      }
    }
  }
}
</script>